<template>
  <transition
    enter-active-class="transition ease-out duration-300"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition ease-in duration-200"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <router-link
      v-if="cartStore.itemCount > 0"
      to="/cart"
      class="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-lg shadow-lg border border-gray-200 p-4 z-40"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-3">
          <div class="h-10 w-10 rounded-full flex items-center justify-center text-white bg-orange-500">
            <ShoppingCartIcon class="h-5 w-5" />
          </div>
          <div>
            <p class="font-medium text-gray-900">
              {{ cartStore.itemCount }} {{ cartStore.itemCount === 1 ? 'item' : 'itens' }}
            </p>
            <p class="text-sm text-gray-500">
              {{ cartStore.formattedTotal }}
            </p>
          </div>
        </div>
        <ChevronRightIcon class="h-5 w-5 text-gray-400" />
      </div>
    </router-link>
  </transition>
</template>

<script setup lang="ts">
import { ShoppingCartIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'
import { useCartStore } from '@/stores'

const cartStore = useCartStore()
</script>
